import { render, staticRenderFns } from "./RequestedDueDate.vue?vue&type=template&id=6b60690e"
import script from "./RequestedDueDate.vue?vue&type=script&lang=js"
export * from "./RequestedDueDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports